import React, { useState, useEffect } from "react";
import {
  FaBars,
  FaTimes,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from "react-router-dom";
// import logoImage from "../assets/images/logoimage.png";
import logoImage from "../assets/images/DailyTaskLogo.png";
import { SidebarLinks } from "../config/staticArray";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(window.innerWidth > 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();
  const useLocation = window.location.pathname;

  const USER_ROLE = JSON.parse(localStorage.getItem("user")).role || "EMPLOYEE"; // Default to CONTRACTOR if not set

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) setIsOpen(true);
      else setIsOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => setIsOpen(!isOpen);

  return (
    <>
      {/* Drawer Toggle Button (always visible on mobile) */}
      {isMobile && (
        <button
          className="btn btn-outline-light position-absolute d-md-none"
          style={{ top: 17, left: 20, zIndex: 10 }}
          onClick={toggleSidebar}
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
      )}

      {/* Sidebar */}
      <div
        className={`bg-dark text-white pt-3 p-1 sidebar-custom ${
          isOpen ? "open" : ""
        } ${isMobile ? "mobile" : "desktop"}`}
        style={{
          width: 250,
          minHeight: "100vh",
          position: isMobile ? "fixed" : "sticky",
          top: 0,
          left: isOpen ? 0 : isMobile ? "-260px" : 0,
          zIndex: 1050,
          transition: "left 0.3s",
          boxShadow: isMobile && isOpen ? "2px 0 8px rgba(0,0,0,0.2)" : "none",
          display: isMobile ? "block" : "block",
        }}
      >
        <div className="d-flex align-items-center mb-3 px-3">
          <img src={logoImage} alt="Logo" height={30} className="me-2" />
          <h5 className="mb-0">{USER_ROLE === "contractor"? "Contractor" : USER_ROLE === "employee" ? "Employee" : "Admin"}</h5>
        </div>
        <ul className="nav flex-column">
          {SidebarLinks.map(
            (link, index) =>
              link.role.includes(USER_ROLE) && (
                <li
                key={index}
                  className={`nav-item mb-2 ${
                     useLocation.match(link.path) ? "bg-white" : "bg-dark"
                  }`}
                  onClick={() => {
                    navigate(link.path);
                    if (isMobile) setIsOpen(false);
                  }}
                >
                  <Link
                    href="/"
                    className={`nav-link ${
                       useLocation.match(link.path) ? "text-dark" : "text-white"
                    }`}
                  >
                    <link.icon className="me-2" /> {link.name}
                  </Link>
                </li>
              )
          )}
        </ul>
      </div>
      {/* Overlay for mobile drawer */}
      {isMobile && isOpen && (
        <div
          onClick={toggleSidebar}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.3)",
            zIndex: 1049,
          }}
        />
      )}
    </>
  );
};

export default Sidebar;
